export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11706.72ce1d10.jpg";